import { render, staticRenderFns } from "./BridgeStatsFilter.vue?vue&type=template&id=adda1486&scoped=true"
import script from "./BridgeStatsFilter.vue?vue&type=script&lang=ts"
export * from "./BridgeStatsFilter.vue?vue&type=script&lang=ts"
import style0 from "./BridgeStatsFilter.vue?vue&type=style&index=0&id=adda1486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adda1486",
  null
  
)

export default component.exports